import { render, staticRenderFns } from "./AuthBridge.vue?vue&type=template&id=149f0a66&"
import script from "./AuthBridge.vue?vue&type=script&lang=js&"
export * from "./AuthBridge.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports